import { Box, Stack } from '@mui/material';
import { Caption, Cell, Text } from '@telegram-apps/telegram-ui';
import dayjs from 'dayjs';
import { ListQuestCompletion } from '../../client/types';
import { toDueDate } from '../../helpers/datetime';
import { CommonIcon } from '../common/CommonIcon';

export type QuestItemCompletedCellProps = {
    completion: ListQuestCompletion;
    questName: string;
};

export const QuestItemCompletedCell = ({ completion, questName }: QuestItemCompletedCellProps) => {
    const nextOccurrence = completion.quest.dueDate
        ? toDueDate(dayjs(completion.quest.dueDate))
        : '';

    const textColor = 'var(--tg-theme-button-text-color)';

    return (
        <Cell
            data-testid="quest-completion"
            subtitle={
                <Stack direction="column" gap="2px">
                    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                        <Stack direction="column" gap="2px" >
                            <Text style={{ color: textColor, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{questName}</Text>
                            <Stack direction="row" alignItems="center" gap="8px" flexWrap="wrap">
                                <Text style={{ fontSize: '13px', color: textColor, fontWeight: 500 }}>
                                    +{completion.completedXp} XP
                                </Text>
                                {nextOccurrence && (
                                    <>
                                        <Text style={{ fontSize: '13px', color: textColor, opacity: 0.7 }}>•</Text>
                                        <Stack direction="row" alignItems="center" gap="4px">
                                            <CommonIcon icon="event" type="outlined" size={14} color={textColor} />
                                            <Caption style={{ color: textColor }}>
                                                Next: {nextOccurrence}
                                            </Caption>
                                        </Stack>
                                    </>
                                )}
                            </Stack>
                        </Stack>
                        <CommonIcon icon="check_circle" type="filled" size={30} color={textColor} />
                    </Stack>
                    {completion.progressedAchievements && completion.progressedAchievements.length > 0 && (
                        <Stack direction="column" gap="4px" mt="8px">
                            <Box sx={{ width: '100%', height: '1px', backgroundColor: textColor, opacity: 0.3 }} />
                            <Text style={{ fontSize: '11px', color: textColor, opacity: 0.7, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                ACHIEVEMENTS PROGRESS
                            </Text>
                            {completion.progressedAchievements.map(pa => {
                                const [current, total] = pa.progressText.split('/');
                                return (
                                    <Stack key={pa.id} direction="row" alignItems="center" justifyContent="space-between">
                                        <Text style={{ fontSize: '13px', color: textColor, opacity: 0.8 }}>
                                            {pa.name}
                                        </Text>
                                        <Stack direction="row" alignItems="center" gap="2px">
                                            <Text style={{ fontSize: '13px', color: textColor, fontWeight: 600 }}>
                                                {current}
                                            </Text>
                                            <Text style={{ fontSize: '13px', color: textColor, opacity: 0.5 }}>
                                                /{total} ({Math.round(pa.progress * 100)}%)
                                            </Text>
                                        </Stack>
                                    </Stack>
                                );
                            })}
                        </Stack>
                    )}
                </Stack>
            }
            style={{ color: textColor }}
        >
        </Cell>
    );
};
